import Component from '../inherited/Component'
import rivets from 'rivets'
import Helpers from '../lib/Helpers'
import AjaxApi from '../lib/AjaxApi'

class ProductBundler extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._jsonElem = this._elem.querySelector('[data-product-bundler-json]')
    this._data = JSON.parse(this._jsonElem.innerHTML)
    this._jquery = window.$ || null
    this._previousSelections = JSON.parse(localStorage.getItem('bundleSelections')) || null

  }

  async mount () {
    this.setDiscount()
    this._data = await this.prepareData(this._data)

    this._binders()
    this._render()
    this._setListeners()

    document.addEventListener('DOMContentLoaded', e => {
      this.setOldVariant()
    })

    document.addEventListener('pageUpdated', e => {
      this.setOldVariant()
      lazyLoadImg.update()
      this._ctx.emit('radiant--lazy-load-update')
      window.sectionInit(e.detail.variant.title)
    })
  }

  setDiscount() {
    let parameter = null;
    let alreadyApproved = localStorage.getItem('affiliate')
    let validDiscount = null;
    let message = document.querySelector('[data-affiliate-message]')
    let nonAffiliateMessage = document.querySelector('[data-non-affiliate-message]')

    if(getUrlParameter('utm_source')) {
      parameter = decodeURIComponent(getUrlParameter('utm_source').trim());
      for(let discount of this._data.discounts) {
        if(discount.sources.includes(parameter)) {
          validDiscount = discount
          break
        }
      }
    } else if(alreadyApproved) {
      for(let discount of this._data.discounts) {
        if(discount.code == alreadyApproved) {
          validDiscount = discount
          break
        }
      }
    }

    if(validDiscount !== null) {
        let discountCode = validDiscount.code

        if(parameter == 'bluemarketmedia') {
            discountCode = 'BLUELIGHT'
        }

        localStorage.setItem('affiliate', discountCode)

        this._discountCode = discountCode
    }

    if(this._discountCode || alreadyApproved) {
        this._affiliateActive = true
        if(message && validDiscount && validDiscount.message) {
            message.innerText = validDiscount.message
            message.classList.remove('hide')
        }
        if(nonAffiliateMessage) {
            nonAffiliateMessage.classList.add('hide')
        }

        document.cookie = `discount_code=${this._discountCode}; path=/`;
        document.dispatchEvent(new Event("cart-updated", { bubbles: true }));
    } else {
        this._affiliateActive = false
    }

    if(getUrlParameter('discount')) {
      document.cookie = `discount=${getUrlParameter('discount')}; path=/`;
    }
  }

  async prepareData (data) {

    if(this._previousSelections?.selected_variant) {
      data.selected_variant = data.variants.find(variant => variant.object.title === this._previousSelections.selected_variant.object.title)
    }
  
    if(!data.selected_variant) {
      data.selected_variant = data.variants.find(variant => variant.object.id === this._options.selectedVariant)
    }

    let discountCode = localStorage.getItem('affiliate') || localStorage.getItem('affiliate_2')
    data.discountPercentage = 1
    data.discountCode = ''
    if(discountCode) {
      let discountToApply = this._data.discounts.find(discount => discount.code == discountCode)
      if(discountToApply) {
        data.discountCode = discountToApply.code
        data.discountPercentage = (1 - (discountToApply.percentage / 100))
      }
    }

    data.total_price = (data.selected_variant.object.price * data.discountPercentage)

    data.quantity = 1

    for (let [index, step] of data.steps.entries()) {
        step.index = index + 1

        if(step.index == 1 || step.object.open) {
            step.open = true
        }

        if(localStorage.getItem('bundleProductUpdate') && step.alternatives) {
          step.open = false
          localStorage.removeItem('bundleProductUpdate')
        }

        if(step.products) {
            step.selected_products = []
            for(let [index, product] of step.products.entries()) {
                let previouslySelected = this._previousSelections?.products?.find(previousProduct => previousProduct.id == product.id)
                product.selected_variant = product.variants.find(variant => variant.title == data.selected_variant.object.title)

                if(!product.selected_variant && data.selected_variant.object.title.includes('Double')) {
                  product.selected_variant = product.variants.find(variant => variant.title.includes('Double'))
                }

                if(product.variants.length == 1) {
                  product.selected_variant = product.variants[0]
                }

                if(product.selected_variant?.title == 'Default Title') {
                  product.selected_variant.title = ''
                }

                if (step.image) {
                  product.featured_image = step.image
                }
                
                if(step.reviews?.length > 0) {
                  product.reviews_widget = step.reviews[index]
                }
                if(step.labels?.length > 0) {
                  product.label = step.labels[index]
                }

                if(step.benefits?.length > 0) {
                  product.benefits = step.benefits[index]
                }

                if(!product.selected_variant) {
                    product.selected_variant = false
                }

                for (let variant of product.variants) {
                  variant.total_value = step.total_values?.find(item => item.product_id === product.id)?.variants?.find(subItem => subItem.variant_id === variant.id)?.total_value
                  variant.original_price = variant.price

                  if(!this._affiliateActive && step.free_products && step.free_products.includes(product.handle)) {
                    if(step.free_products_valid.length == 0 || step.free_products_valid.includes(data.selected_variant.object.title)) {
                      variant.display_price = variant.original_price
                      variant.price = 0
                      variant.free = true
                    }
                  } else {
                    variant.display_price = null
                    variant.price = variant.original_price
                    variant.free = false
                  }
                }

                if(previouslySelected && product.selected_variant.available) {
                  step.selected_products.push(product)

                  for(let product of step.selected_products) {
                    this._data.total_price = this._data.total_price + product.selected_variant.price
                  }

                  step.open = true
                } else if(step.promotion && step.promotion.product && step.promotion.product.id == product.id) {
                  step.selected_products = []
                  step.selected_products.push(product)
                }

                for (let variant of product.variants) {
                  if(variant.free) {
                    step.products.unshift(step.products.splice(index, 1)[0]);

                    if(step.selected_products && step.selected_products.length == 0) {
                      step.selected_products.push(product)
                    }
                    break
                  }
                }
            }
        }

        if(step.byo?.products) {

          step.byo_data = structuredClone(step.byo)

          for (let product of step.byo.products) {
            for (let variant of product.variants) {
              variant.total_value = step.byo.total_values?.find(item => item.product_id === product.id)?.variants?.find(subItem => subItem.variant_id === variant.id)?.total_value
            } 
          }

          if(step.byo.position) {
            let byoPosition = step.byo.position - 1
            step.products.splice(byoPosition, 0, step.byo)
          } else {
            step.products.push(step.byo)
          }
        }

        if(step.products) {
          step.displayProducts = step.products.filter(product => product.selected_variant != false)
        }
        
    }

    if(data.gifts) {
      data.gifts_enable = true
      if(data.gifts_status == 'non-affiliate' && this._affiliateActive) {
        data.gifts_enable = false
      } else if(data.gifts_status == 'url' && data.gifts_parameter) {
        let parameter = data.gifts_parameter.split('=')[0]
        let parameterValue = data.gifts_parameter.split('=')[1].trim()
        if(!getUrlParameter(parameter) || getUrlParameter(parameter).trim() != parameterValue) {
          data.gifts_enable = false
        }
        if(window.getCookie('discount') && window.getCookie('discount') == parameterValue) {
          data.gifts_enable = true
        }
      }
      if(data.gifts_enable) {
        let message = document.querySelector('[data-gift-message]')
        message.innerText = data.gifts_message
        message.classList.remove('hide')
        data.selected_gifts = []
        for(let product of data.gifts) {

          if(!product.available) {
            data.gifts = data.gifts.filter(giftProduct => giftProduct != product)
          }

          product.selected_variant = product.variants.find(variant => variant.option1 == data.selected_variant.object.title || variant.option2 == data.selected_variant.object.title)

          product.options_with_values = []

          let option1 = product.variants.map(variant => variant.option1)
          let option1Arr = [...new Set(option1)]
          product.option1 = {
            "id": "option1",
            "index": 1,
            "title": product.options[0],
            "values": option1Arr
          }

          let option2 = product.variants.map(variant => variant.option2)
          let option2Arr = [...new Set(option2)]
          product.option2 = {
            "id": "option2",
            "index": 2,
            "title": product.options[1],
            "values": option2Arr
          }

          product.options_with_values.push(product.option1, product.option2)

          if(!product.selected_variant && data.selected_variant.object.title.includes('Double')) {
            product.selected_variant = product.variants.find(variant => variant.title.includes('Double'))
          }

          if(product.variants.length == 1) {
            product.selected_variant = product.variants[0]
          }
          
          if(!product.selected_variant?.available) {
            let availableVariant = product.variants.find(variant => variant.available)
            if(availableVariant) {
              product.selected_variant = availableVariant
            }
          }

          if(product.selected_variant?.title == 'Default Title') {
            product.selected_variant.title = ''
          }

          for (let variant of product.variants) {
            variant.total_value = data.gift_total_values?.find(item => item.product_id === product.id)?.variants?.find(subItem => subItem.variant_id === variant.id)?.total_value
          }
        }
      }
    }

    if(!data.gifts || data.gifts.length == 0) {
      data.gifts_enable = false
    }

    this.setPreBuiltSaving()

    console.log('productBundler', data)

    return data
  }

  _render () {
    if(this._elem.classList.contains('rendered')) return
    this._bind = rivets.bind(this._elem, this._getModel())
    this._elem.classList.add('rendered')
  }

  _setListeners () {
    this._accordionItems = this._elem.querySelectorAll('[data-bundle-builder-step]')

    for (let elem of this._accordionItems) {
      this._theme.mountComponents(elem)
    }
  }

  _update () {
    this._data.steps = [...this._data.steps]

    let sliders = this._elem.querySelectorAll('[data-keen-slider]')
    for(let sliderElem of sliders) {
      let slider = this._theme.getComponentByElem(sliderElem).component._slider
      slider.update()
    }

    this._data.total_price = (this._data.selected_variant.object.price * this._data.discountPercentage)

    
    let selections = {}
    selections.selected_variant = this._data.selected_variant
    selections.products = []

    for(let step of this._data.steps) {
      if(step.selected_products && step.selected_products.length > 0) {
        for(let product of step.selected_products) {
          selections.products.push(product)
          this._data.total_price = this._data.total_price + product.selected_variant.price
        }
      }
    }

    this.setOldVariant()
    this.setPreBuiltSaving(this._data)

    localStorage.setItem('bundleSelections', JSON.stringify(selections))
  }

  setOldVariant () {

    let pricesToUpdate = document.querySelectorAll('.js-radiant-price')
    for(let price of pricesToUpdate) {
      price.classList.add('is-loading')
    }

    this._elem.closest('.product__info-container')?.querySelector(`variant-dropdown [name="id"][value="${this._data.selected_variant.object.id}"]`)?.click()

  }

  setPreBuiltSaving() {
    if(this._data.components) {
      for(let [index, product] of this._data.components.products.entries()) {
        product.image = this._data.components.images[index]
      }
      let productPrice = this._data.selected_variant.object.price
      let componentTotal = 0
      for(let [index, product] of this._data.components.products.entries()) {
        let totalValue = this._data.components.product_variants[index]?.variants.find(componentVariant => componentVariant.variant_title == this._data.selected_variant.object.title)
        if(!totalValue) {
          if(this._data.components.product_variants[index]?.variants.length == 1) {
            totalValue = this._data.components.product_variants[index].variants[0]
          }
          if(this._data.selected_variant.object.title.includes('Double') && this._data.components.product_variants[index]?.variants.find(componentVariant => componentVariant.variant_title.includes('Double'))) {
            totalValue = this._data.components.product_variants[index]?.variants.find(componentVariant => componentVariant.variant_title.includes('Double'))
          }
        }
        if(totalValue) {
          componentTotal = componentTotal + totalValue.total_value
        }
      }

      this._data.pre_built_saving = componentTotal - productPrice
    }
  }

  _getModel () {
    return {
      data: this._data,
      controller: {
        switchVariant: async (e, model) => {

            if(this._data.selected_variant == model.variant) return

            model.selected_variant = model.variant
            this._data.selected_variant = model.variant

            for(let step of this._data.steps) {
                if(step.products) {
                    for(let [index, product] of step.products.entries()) {
                        if(product.byo) {
                          step.selected_products = []
                          product.title = step.byo_data.title
                          product.handle = null
                          product.selected_variant = null
                          product.text = step.byo_data.text
                        } else {
                          product.selected_variant = product.variants.find(variant => variant.title == this._data.selected_variant.object.title)

                          if(product.variants.length == 1) {
                            product.selected_variant = product.variants[0]
                          }

                          if(!product.selected_variant && this._data.selected_variant.object.title.includes('Double')) {
                            product.selected_variant = product.variants.find(variant => variant.title.includes('Double'))
                          }

                          let masterVariantValues = this._elem.querySelectorAll('[data-master-variant-value]')
                          for(let master of masterVariantValues) {
                            master.value = this._data.selected_variant.object.title
                            master.dispatchEvent(new Event('change', { 'bubbles': true }))
                          }

                          if(!product.selected_variant) {
                              product.selected_variant = false
                              step.selected_products = []
                          }
                        }

                        if(!this._affiliateActive && step.free_products && step.free_products.includes(product.handle)) {
                          if(step.free_products_valid.length == 0 || step.free_products_valid.includes(this._data.selected_variant.object.title)) {
                            product.selected_variant.display_price = product.selected_variant.original_price
                            product.selected_variant.free = true
                          } else {
                            product.selected_variant.display_price = null
                            product.selected_variant.free = false
                          }
                        }
                    }

                    step.displayProducts = step.products.filter(product => (product.byo == true || product.selected_variant != false))
                }

                if(step.products?.length > 0 && step.displayProducts?.length == 0) {
                  step.hide = true
                } else {
                  step.hide = false
                }
            }

            model.step.open = false
            
            this._update()
            if(this._data.steps[model.step.index]) {
              this._data.steps[model.step.index].open = true
            }
        },
        toggleProduct: async (e, model) => {
            let step = model.step
            if(step.upgrade 
              || e.target.classList.contains('bundle-builder__step-product-tooltip')
              || e.target.classList.contains('product-popup-modal__opener')
              || e.target.dataset.totalValueTooltip) 
            {
              return
            } else if(model.product.byo) {
              let elems = document.querySelectorAll('[data-byo-toggle]')
              for(let elem of elems) {
                elem.classList.toggle('visible')
              }
              document.querySelector('body').classList.toggle('overflow-hidden')

              window.Collapses.map((collapse, index) => {
                if(collapse.element.classList.contains('bedframe-collapse')){
                  collapse.recalculate()
                }
              });

              this._divanAddButton = document.querySelector('.divan-bed__popup-add')
              if(this._divanAddButton) {
                if(step.selected_products.some(product => product == model.product)) {
                  this._divanAddButton.innerText = 'ADDED'
                } else {
                  this._divanAddButton.innerText = 'ADD'
                }
                this._divanAddButton.addEventListener('click', e => {
                  let variantTitle = this._divanAddButton.dataset.variant.replaceAll(',', ' / ')
                  let productHandle = this._divanAddButton.dataset.product_id
                  let byoProduct = step.byo.products.find(product => product.handle == productHandle)
                  if(productHandle && variantTitle) {
                    let byoVariant = byoProduct.variants.find(variant => variant.title == variantTitle)
                    model.product.handle = byoProduct.handle
                    model.product.title = byoProduct.title
                    model.product.selected_variant = byoVariant
                    model.product.text = ''

                    if(!step.object.multiple) {
                      step.selected_products = []
                    }

                    step.selected_products.push(model.product)
                    step.selected_byo = true

                    this._update()
                    if(this._data.steps[step.index]) {
                      this._data.steps[step.index].open = true
                    }
                  }
                })
              }

            } else {

              if(!step.object.multiple) {
                step.selected_products = []
              }
              
              let alreadySelected = step.selected_products.some(product => product == model.product)
              if(alreadySelected) {
                  step.selected_products = step.selected_products.filter(product => product != model.product)
              } else {
                  step.selected_products.push(model.product)
                  
                  if(!step.object.multiple) {
                    step.open = false
                  }
              }
              
            }
            this._update()
            if(this._data.steps[step.index]) {
              this._data.steps[step.index].open = true
            }
        },
        toggleGift: async (e, model) => {
          if(e.target.nodeName == 'SELECT' || e.target.dataset.giftOptionLabel || !model.product.selected_variant || !model.product.selected_variant?.available) return
          let alreadySelected = this._data.selected_gifts.some(product => product == model.product)
          if(alreadySelected) {
            this._data.selected_gifts = this._data.selected_gifts.filter(product => product != model.product)
          } else if(this._data.selected_gifts.length != this._data.gifts_limit) {
            this._data.selected_gifts.push(model.product)
          }
        },
        clearProduct: async (e, model) => {
            if(model.product) {
              model.step.selected_products = model.step.selected_products.filter(product => product != model.product)
            } else {
              model.step.selected_products = []
            }
            this._update()
            if(this._data.steps[model.step.index]) {
              this._data.steps[model.step.index].open = true
            }
        },
        updateSwatch: async (e, model) => {
          let swatchInput = e.target.previousElementSibling
          let colourDropdown = e.target.closest('.gift-option').querySelector('select')
          swatchInput.checked = true
          colourDropdown.value = swatchInput.value
          colourDropdown.dispatchEvent(new Event('change', { 'bubbles': true }))
        },
        findGiftVariant: async(e, model) => {
          let option1 = document.querySelector(`[data-gift-option="${model.product.id}"][data-id="option1"]`).value
          let option2 = document.querySelector(`[data-gift-option="${model.product.id}"][data-id="option2"]`).value
          let chosenVariant = null
          for (let prodVariant of model.product.variants) {
            if(option2) {
              if (prodVariant.option1 === option1 && prodVariant.option2 === option2) {
                chosenVariant = prodVariant
              }
            } else {
              if (prodVariant.option1 === option1) {
                chosenVariant = prodVariant
              }
            }
          }
          if(chosenVariant) {
            model.product.selected_variant = chosenVariant
          } else {
            model.product.selected_variant = null
          }
        },
        toggleStep: async (e, model) => {
            model.step.open = !model.step.open
        },
        updateQuantity: async (e, model) => {
            this._data.quantity = Number(e.target.value)
        },
        addToCart: async (e, model) => {
          try {

            let items = []

            if(this._data.pre_built) {
              for(let component of this._data.components.product_variants) {
                let matchingVariant = component.variants.find(variant => variant.variant_title == this._data.selected_variant.object.title)
                if(!matchingVariant && this._data.selected_variant.object.title == 'Small Double') {
                  matchingVariant = component.variants.find(variant => variant.variant_title.includes('Double'))
                }
                if(!matchingVariant && component.variants.length == 1) {
                  matchingVariant = component.variants[0]
                }
                items.push({
                    id: matchingVariant.variant_id,
                    quantity: this._data.quantity,
                    properties: {
                      '_bundle': true
                    }
                })
              }
            } else {
              items.push({
                  id: this._data.selected_variant.object.id,
                  quantity: this._data.quantity
              })

              for (let step of this._data.steps) {
                  if(step.selected_products?.length > 0) {
                      for(let product of step.selected_products) {
                        items.push({
                            id: product.selected_variant.id,
                            quantity: this._data.quantity
                        })
                      }
                  }
              }
            }

            if(this._data.selected_gifts?.length > 0) {
              for(let gift of this._data.selected_gifts) {
                items.push({
                    id: gift.selected_variant.id,
                    quantity: 1
                })
              }
            }

            let data = await AjaxApi.addToCart({
                items: items
              }, this._ctx.getState())
            

            if(window.liquidAjaxCart) {
              window.liquidAjaxCart.update()
            }
              
            if(this._discountCode) {
              setTimeout(() => {                
                document.cookie = `discount_code=${this._discountCode}; path=/`;
                fetch(`/discount/${this._discountCode}`)
                .then(function() {
                    if(window.liquidAjaxCart) {
                      window.liquidAjaxCart.update()
                    }
                    if(document.querySelector('cart-drawer')) {
                      document.querySelector('cart-drawer').open()
                    } else {
                      window.location = '/cart'
                    }
                })
                .catch(function(error) {
                    console.error('Error:', error);
                });
              }, 500)
            } else {
              if(window.liquidAjaxCart) {
                window.liquidAjaxCart.update()
              }
              if(document.querySelector('cart-drawer')) {
                document.querySelector('cart-drawer').open()
              } else {
                window.location = '/cart'
              }
            }

            
          } catch (e) {
            console.error('error', e)
            if (e.response) {
              alert(e.response.data.message)
              console.log(e.response)
              this._data.adding_to_cart = false
            }
          }
        },
        changeURL: async(e, model) => {
          e.preventDefault()
          let newUrl = `${e.target.dataset.url}${e.target.dataset.handle}`
          fetch(newUrl)
          .then((response) => response.text())
          .then((responseText) => {

            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const destination = document.querySelector('.bundle-builder-section')
            const source = html.querySelector('.bundle-builder-section')
            
            if (source && destination) destination.innerHTML = source.innerHTML;

            localStorage.setItem('bundleProductUpdate', true)
            window.history.replaceState({ }, '', newUrl)
            this._theme.mountComponents(destination)

            document.dispatchEvent(new CustomEvent("pageUpdated", { 'detail': {
              'variant': this._data.selected_variant.object
            }}));
            
          })
          .catch((err) => {
            console.error(err)
          })
        }
      }
    }
  }

  _binders () {
    rivets.formatters.getSrcSet = (src, size) => {
      return src ? `${Helpers.getSizedImageUrl(src, size)} 1x, ${Helpers.getSizedImageUrl(src, size + '@2x')} 2x` : ''
    }

    rivets.formatters.getSrcSet = (src, size) => {
      return src ? `${Helpers.getSizedImageUrl(src, size)} 1x, ${Helpers.getSizedImageUrl(src, size + '@2x')} 2x` : ''
    }


    rivets.formatters.productIsSelected = (products, product) => {
      return products.find(item => item.handle === product.handle)
    }

    rivets.formatters.variantIsSelected = (variantId, selectedVariantId) => {
        return (variantId == selectedVariantId)
    }

    rivets.formatters.getSizedImage = (src, size) => {
      return src ? Helpers.getSizedImageUrl(src, size) : ''
    }

    rivets.formatters.getTotalValue = (price, product, variant) => {
      return `<span>${window.cartStrings.totalValueHtml}: ${price}</span> <span data-total-value-tooltip="${product?.handle}|${variant?.id}">i</span>`
    }

    rivets.formatters.append = (one, two) => {
      return `${one}${two}`
    }

    rivets.formatters.getStepTitle = (step) => {
      let stepTitle = this._ctx.getState().locale.bundleStepTitle
      if(this._data.pre_built) {
        stepTitle = this._ctx.getState().locale.bundleStepTitlePrebuilt
      }
      return stepTitle
      .replace('[title]', step?.object?.title)
      .replace('[count]', step?.index)
    }

    rivets.formatters.toArr = (count) => {
      let result = []
      for (let i = 0; i < count; i++) {
        result.push(i)
      }
      return result
    }
    
    rivets.formatters.getSelectedTitle = (products) => {
      return products?.map(product => product.title).toString()
    }

    rivets.formatters.getSelectedColour = (variant, index) => {
      if(!variant) return
      let numIndex = index - 1
      return variant.options[numIndex]
    }

    rivets.formatters.moneyWithFree = (value) => {
      return value > 0 ? Helpers.formatMoney(value, this._ctx.getState()) : this._ctx.getState().locale.free
    }

    rivets.formatters.money = (value) => {
      return Helpers.formatMoney(value, this._ctx.getState())
    }

    rivets.formatters.moneyWithDiscount = (value) => {
      return Helpers.formatMoney((value * this._data.discountPercentage), this._ctx.getState())
    }

    rivets.formatters.moneyWithUpgradeDiscount = (value, product) => {
      if(product.discounts) {
        let upgradeDiscount = product.discounts.find(productDiscount => productDiscount.code == this._data.discountCode)
        if(upgradeDiscount) {
          return Helpers.formatMoney((value * this._data.discountPercentage), this._ctx.getState())
        }
      }
      return Helpers.formatMoney(value, this._ctx.getState())
    }

    rivets.formatters.getProductCount = (products, product, variant) => {
      return products.filter(item => item.handle === product.handle && item.selected_variant && item.selected_variant.id === variant.id).length
    }

    rivets.formatters.getIndex = (arr, index) => {
      return arr[index]
    }

    rivets.formatters.length = (arr) => {
      return arr ? arr.length : 0
    }

    rivets.formatters.isFinalStep = (step) => {
      return step === this._data.steps.length
    }

    rivets.formatters.handleize = (arr) => {
      return Helpers.handleize(arr)
    }

    rivets.formatters.and = (val, val2) => {
      return val && val2
    }

    rivets.formatters.eq = (val, val2) => {
      return val === val2
    }

    rivets.formatters.or = (val, val2) => {
      return val || val2
    }

    rivets.formatters.notEq = (val, val2) => {
      return val !== val2
    }

    rivets.formatters.gt = (val, val2) => {
      return val > val2
    }

    rivets.formatters.not = (val) => {
      return !val
    }

    rivets.formatters.getUrl = (handle) => {
      return `/products/${handle}`
    }

    rivets.formatters.getTotalSavingValue = () => {
      let total_price = this._data.selected_variant.total_value

      for(let step of this._data.steps) {
        if(step.selected_products?.length > 0) {
          for(let product of step.selected_products) {
            if(product.selected_variant && product.selected_variant.total_value) {
              total_price += product.selected_variant.total_value
            }
          }
        }
      }

      return total_price
    }

    rivets.formatters.canProceed = (selectedProducts) => {
      let variantCount = selectedProducts.filter(product => product.selected_variant && product.selected_variant.available).length
      return variantCount === this._data.current_step.product_limit
    }

    rivets.formatters.pluralize = (count, one, multiple) => {
      return count === 1 ? one : multiple
    }

    rivets.formatters.prepend = (one, two) => {
      return `${two}${one}`
    }
 
    rivets.formatters.toJson = (item) => {
      return JSON.stringify(item)
    }

    rivets.formatters.getVariantOptions = (option, product) => {
      let arr = []
      for (let value of option.values) {
        arr.push({
          label: value,
          value: value
        })
      }
      return JSON.stringify(arr)
    }

    rivets.formatters.toTitleCase = (string) => {
      if(!string) return
      return string
        .toLowerCase()
        .replaceAll('the nectar ', '')
        .replaceAll('nectar ', '')
        .replaceAll('the ', '')
        .replaceAll('organic cotton ', '')
        .replaceAll(',', ', ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    }

    rivets.formatters.replace = (string, one, two) => {
      return string.replace(one, two)
    }

    rivets.formatters.getPriceDiff = (price, selectedPrice) => {
      if(price > selectedPrice) {
        let diff = price - selectedPrice
        return diff
      } else {
        return
      }
    }

    rivets.formatters.isOptionSelected = (variant, option, value) => {
      if(variant && variant[option.id] == value) {
        return 'selected'
      }
      return null
    }

    rivets.binders['set-class'] = function(el, value){
      if (el.classList.contains(value)) {
        el.classList.remove(value)
      }
      el.classList.add(value)
    }
  }

}

export default ProductBundler
